/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Questionnaire_Editor_No_QuestionsInputs */

const en_admin_questionnaire_editor_no_questions = /** @type {(inputs: Admin_Questionnaire_Editor_No_QuestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No questions yet`)
};

const nl_admin_questionnaire_editor_no_questions = /** @type {(inputs: Admin_Questionnaire_Editor_No_QuestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen vragen`)
};

/** @type {(inputs: Admin_Questionnaire_Editor_No_QuestionsInputs) => LocalizedString} */
const de_admin_questionnaire_editor_no_questions = en_admin_questionnaire_editor_no_questions;

/** @type {(inputs: Admin_Questionnaire_Editor_No_QuestionsInputs) => LocalizedString} */
const es_admin_questionnaire_editor_no_questions = en_admin_questionnaire_editor_no_questions;

/** @type {(inputs: Admin_Questionnaire_Editor_No_QuestionsInputs) => LocalizedString} */
const fr_admin_questionnaire_editor_no_questions = en_admin_questionnaire_editor_no_questions;

/** @type {(inputs: Admin_Questionnaire_Editor_No_QuestionsInputs) => LocalizedString} */
const it_admin_questionnaire_editor_no_questions = en_admin_questionnaire_editor_no_questions;

/** @type {(inputs: Admin_Questionnaire_Editor_No_QuestionsInputs) => LocalizedString} */
const pt_br2_admin_questionnaire_editor_no_questions = en_admin_questionnaire_editor_no_questions;

/** @type {(inputs: Admin_Questionnaire_Editor_No_QuestionsInputs) => LocalizedString} */
const pl_admin_questionnaire_editor_no_questions = en_admin_questionnaire_editor_no_questions;

/** @type {(inputs: Admin_Questionnaire_Editor_No_QuestionsInputs) => LocalizedString} */
const hu_admin_questionnaire_editor_no_questions = en_admin_questionnaire_editor_no_questions;

/** @type {(inputs: Admin_Questionnaire_Editor_No_QuestionsInputs) => LocalizedString} */
const ro_admin_questionnaire_editor_no_questions = en_admin_questionnaire_editor_no_questions;

/**
* | output |
* | --- |
* | "No questions yet" |
*
* @param {Admin_Questionnaire_Editor_No_QuestionsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_questionnaire_editor_no_questions = /** @type {((inputs?: Admin_Questionnaire_Editor_No_QuestionsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Questionnaire_Editor_No_QuestionsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_questionnaire_editor_no_questions(inputs)
	if (locale === "de") return de_admin_questionnaire_editor_no_questions(inputs)
	if (locale === "es") return es_admin_questionnaire_editor_no_questions(inputs)
	if (locale === "fr") return fr_admin_questionnaire_editor_no_questions(inputs)
	if (locale === "nl") return nl_admin_questionnaire_editor_no_questions(inputs)
	if (locale === "it") return it_admin_questionnaire_editor_no_questions(inputs)
	if (locale === "pt-BR") return pt_br2_admin_questionnaire_editor_no_questions(inputs)
	if (locale === "pl") return pl_admin_questionnaire_editor_no_questions(inputs)
	if (locale === "hu") return hu_admin_questionnaire_editor_no_questions(inputs)
	return ro_admin_questionnaire_editor_no_questions(inputs)
});
export { admin_questionnaire_editor_no_questions as "admin.questionnaire_editor.no_questions" }